import axios from "axios";

// The illustrated "General" sticker pack, curated in idx-pins and served from
// blob storage. A non-null result is authoritative; null = endpoint unreachable
// (e.g. not deployed yet) → the editor falls back to the code-generated General
// set so the feature never goes blank.
export interface StickerDesign {
    id: string;
    label: string;
    slug: string | null;
    artwork_url: string;
    pack: string | null;
    published: boolean;
    sort_order: number;
    date_created: string;
    date_updated: string;
}

const StickerDesignsService = {
    getGeneral: async (pack?: string): Promise<StickerDesign[] | null> => {
        return axios
            .get(`${process.env.REACT_APP_MCTWIST_USER_SERVER}/stickers/general`, {
                params: pack ? { pack } : undefined,
            })
            .then((response) => (response.data?.data ?? null) as StickerDesign[] | null)
            .catch((error) => {
                console.error(error);
                return null;
            });
    },
};

export default StickerDesignsService;
